import React from "react";

const WaveBackground = ({ children, bgColor = "#3B82F6", isCardCover }) => {
  return (
    <div
      className={`relative ${
        !isCardCover ? "min-h-screen" : "h-20"
      }  w-full flex items-center justify-center overflow-hidden`}
      style={{ backgroundColor: `${bgColor}33` }} // Hintergrundfarbe mit 20% Opazität
    >
      <svg
        className="absolute inset-0 w-full h-full"
        preserveAspectRatio="none"
        viewBox="0 0 1440 800"
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          <linearGradient id="wave-gradient" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" stopColor={`${bgColor}33`} /> {/* 20% Opazität */}
            <stop offset="100%" stopColor={`${bgColor}33`} />{" "}
            {/* 20% Opazität */}
          </linearGradient>
        </defs>

        {/* Background wave */}
        <path
          fill="url(#wave-gradient)"
          d="M0,128L48,138.7C96,149,192,171,288,186.7C384,203,480,213,576,218.7C672,224,768,224,864,213.3C960,203,1056,181,1152,181.3C1248,181,1344,203,1392,213.3L1440,224L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
        />

        {/* Middle wave */}
        <path
          fill={`${bgColor}26`} // 15% Opazität
          d="M0,256L48,240C96,224,192,192,288,181.3C384,171,480,181,576,192C672,203,768,213,864,229.3C960,245,1056,267,1152,266.7C1248,267,1344,245,1392,234.7L1440,224L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
        />

        {/* Foreground wave */}
        <path
          fill={`${bgColor}1A`} // 10% Opazität
          d="M0,288L48,277.3C96,267,192,245,288,234.7C384,224,480,224,576,234.7C672,245,768,267,864,277.3C960,288,1056,288,1152,277.3C1248,267,1344,245,1392,234.7L1440,224L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
        />
      </svg>
      <div className="relative z-10">{children}</div>
    </div>
  );
};

export default WaveBackground;
